import React, { lazy } from "react";
import DashboardLayout from "layout/LayoutContainers/DashboardLayout";
import PostAddIcon from "@mui/icons-material/PostAdd";
import LogoutIcon from "@mui/icons-material/Logout";

const NewSikap = lazy(() => import("components/Dashboard/Sikaps/New Sikap/index"));
const Logout = lazy(() => import("components/Auth/Logout"));

const eouRoutes = [
  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
  },
  {
    type: "collapse",
    name: "Add New Sikap",
    key: "/sikaps/add",
    route: "/sikaps/add",
    component: (
      <DashboardLayout>
        <NewSikap />
      </DashboardLayout>
    ),
    noCollapse: true,
    icon: <PostAddIcon />,
  },
  { type: "divider", key: "divider-7" },
  { type: "title", title: "Profile", key: "profile-pages" },
  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "logout",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-3" },
];

export default eouRoutes;
